import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tv",
  "use": "tv-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"tv\">\n<path d=\"M20,23H4c-1.7,0-3-1.3-3-3V9c0-1.7,1.3-3,3-3h16c1.7,0,3,1.3,3,3v11C23,21.7,21.7,23,20,23z M4,8C3.4,8,3,8.4,3,9v11\n\tc0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V9c0-0.6-0.4-1-1-1H4z\" />\n<path d=\"M12,8c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L12,5.6l4.3-4.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-5,5\n\tC12.5,7.9,12.3,8,12,8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol